import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'alpha.300',
    endColor: 'alpha.400',
    minW: 'full',
    h: '20',
    borderRadius: 'md',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    boxShadow: 'none',
    borderRadius: 'base',
    mb: '0',
    border: 'none',
    _hover: {
      '&&': {
        _placeholder: {
          color: 'gamma.700',
        },
        border: 'none',
        boxShadow: 'none',
      },
      color: 'gamma.200',
    },
    _focus: {
      '&&': {
        _placeholder: {
          color: 'gamma.700',
        },
        border: 'none',
        boxShadow: 'none',
      },
      color: 'gamma.200',
      textShadow: 'sm',
    },
    _placeholder: {
      color: 'gamma.700',
      fontWeight: 'bold',
      fontSize: 'xs',
    },
    sx: {
      '&&': {
        bg: '#6B0003',
        color: 'gamma.200',
        _placeholder: {
          color: 'gamma.700',
        },
      },
    },
  },
  inputRightIcon: {
    color: 'gamma.400',
    boxSize: '4',
    as: Search,
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '2',
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: {
    alignItems: 'center',
    gap: 2,
    flex: 1,
    textAlign: 'left',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
  },
  accordionButtonIconSvg: {
    color: 'gamma.400',
    fontSize: 'md',
  },
  accordionButtonText: {
    fontSize: 'md',
    fontWeight: 'normal',
    color: 'gamma.200',
    fontFamily: 'accentMusashi',
    textTransform: 'uppercase',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'gamma.200',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'gamma.500',
  },
  accordionPanel: {
    p: '0',
    mb: '3',
  },
};
